const GetStarted = () => {
    return (
        <div>Get Started Works</div>
    )
};

export default GetStarted;